import * as _ from 'lodash';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'app/types/user';
import { int } from 'aws-sdk/clients/datapipeline';
import { environment } from 'environments/environment';
import { LogService } from './log.service';
import { SpinnerService } from './spinner.service';
import {saveAs} from 'file-saver'
import { ErrorsDialogService } from './errors-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class AuditService {
  user: User;
  fileCount: int;
  fileTransffered: int;
  blobStreams = [];
  errorMsg: string;
  
  constructor(
    private http: HttpClient,
    private spinner: SpinnerService,
    private log: LogService,
    private errorsDialog: ErrorsDialogService
  ) {}
  
  auditEvent(
    username: string,
    apiName: string,
    description: string,
    data: any
  ) {
    this.http
      .post(environment.api.auditActivity, {
        username,
        apiName,
        description,
        data
      })
      .subscribe(_.noop, _.noop);
  }

  setUser(user:User){
    this.user=user;
  }

  updateBlob(blobStream:Blob) {
    this.blobStreams.push(blobStream);
    this.fileTransffered=this.fileTransffered+1;
    this.log.trace('updateBlob file Count:'+this.fileCount+' fileTransffered count:'+this.fileTransffered);
    this.downloadFile();
  };

  downloadFile(){
    if (this.fileCount == this.fileTransffered){
      this.spinner.hideSpinner();
      //Once file content is transffered to object than create new report file
      this.log.trace('saveAs blob stream');
      let blob = (new Blob(this.blobStreams, { type: "text/csv" }));
      saveAs(blob, 'User-Activity-log-report.csv');
    }
  }
  private getServerErrorMessage(error: HttpErrorResponse): string {
    switch (error.status) {
        case 404: {
            return `Not Found: ${error.message}`;
        }
        case 403: {
            return `Access Denied: ${error.message}`;
        }
        case 500: {
            return `Internal Server Error: ${error.message}`;
        }
        default: {
            return `Unknown Server Error: ${error.message}`;
        }
    }
  }
  downloadAuditReport() {
    this.fileCount=0;
    this.fileTransffered=0;
    this.blobStreams = [];
    
    let baseUrl ='assets/data/auditreport/Healthshare/auditreports/';
    if (environment.releaseEnv=='train'){
      if (this.user.securityGroups.length > 0 ){
        try{
          var todaysDate= new Date();
          const day = todaysDate.getDate();
          const dayWithZero = day.toString().length > 1 ? day : '0' + day;
          const month = todaysDate.getMonth() + 1;
          const monthWithZero = month.toString().length > 1 ? month : '0' + month;
          const year = todaysDate.getFullYear();
          var filePostFix = year+'-'+monthWithZero+'-'+dayWithZero;
          this.http.get(baseUrl+'MX_CA_MX.csv', {responseType: 'blob'})
            .subscribe(response => {
              this.fileCount=this.fileCount+1;
              let blob = new Blob([response], { type: 'text/csv' });
              this.updateBlob(blob);
              this.log.trace('blob updated');
            },catchError =>{
              this.fileTransffered=this.fileTransffered+1;
              this.downloadFile();
              if (catchError.error instanceof ErrorEvent) {
                this.errorMsg = `Error: ${catchError.error.message}`;
              } else {
                this.errorMsg = this.getServerErrorMessage(catchError);
              }
              this.log.trace('User activity log file content read error->', this.errorMsg);
          });
        }catch (err){
          this.spinner.hideSpinner();
          this.log.trace('Facility Name file content read error->', err);
        }
      }else{
        const errors = [];
        errors.push('Invalid facility name ');
        errors.push('Please assign facility to user');
        this.errorsDialog.open(errors);
      }
    }else{
        for (var facName of this.user.securityGroups) {
          if (facName.startsWith('facility-')){
            let userFac=facName.split('-')[1]+'.csv';
            this.fileCount=this.fileCount+1;
            if (this.fileCount > 0){
              this.spinner.showSpinner();
            }
            try{
              this.http.get(baseUrl+userFac, {responseType: 'blob'})
              .subscribe(response => {
                let blob = new Blob([response], { type: 'text/csv' });
                this.updateBlob(blob);
              },catchError =>{
                this.fileTransffered=this.fileTransffered+1;
                this.downloadFile();
                if (catchError.error instanceof ErrorEvent) {
                  this.errorMsg = `Error: ${catchError.error.message}`;
                } else {
                  this.errorMsg = this.getServerErrorMessage(catchError);
                }
                this.log.trace('User activity log file content read error->', this.errorMsg);
              });
            }catch (err){
                this.spinner.hideSpinner();
                this.log.trace('Facility Name file content read error->', userFac+err);
              }
            }
        }
      }
  }
}
